import { render, staticRenderFns } from "./ClearMFA.vue?vue&type=template&id=80f74c02&scoped=true"
import script from "./ClearMFA.vue?vue&type=script&lang=ts"
export * from "./ClearMFA.vue?vue&type=script&lang=ts"
import style0 from "./ClearMFA.vue?vue&type=style&index=0&id=80f74c02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f74c02",
  null
  
)

export default component.exports